import '@/styles/global.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { RecoilRoot } from 'recoil';

import { App } from '@/App';
import reportWebVitals from '@/reportWebVitals';

import { QueryClientProvider } from './hooks';
import { GlobalComponents, GoogleTagManager } from './components';

const rootNode = document.getElementById('root');
const root = createRoot(rootNode!);

root.render(
  <React.StrictMode>
    <QueryClientProvider>
      <RecoilRoot>
        <GlobalComponents />
        <GoogleTagManager id={process.env.REACT_APP_GTAG_CONTAINER_ID as string} />
        <div id="backdrop" />
        <App />
      </RecoilRoot>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
